import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ViewModelSharingUserRoleType } from '@view-model/domain/view-model';

type Props = {
  sharingUserRole: ViewModelSharingUserRoleType;
  isPublicWorkspace: boolean;
  onChange(role: ViewModelSharingUserRoleType): void;
  disabled: boolean;
};

export const ShareSetting: React.FC<Props> = ({ sharingUserRole, isPublicWorkspace, onChange, disabled }: Props) => {
  const { t } = useTranslation();
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(ViewModelSharingUserRoleType.load(event.target.value));
  };

  return (
    <div>
      <p className="pb-1">{t('canvas.viewModelSetting.shareDescription')}</p>
      <select
        className="form-select block w-64 py-1 text-sm"
        value={sharingUserRole}
        onChange={handleChange}
        disabled={disabled}
      >
        {ViewModelSharingUserRoleType.values(isPublicWorkspace).map((roleType) => (
          <option key={roleType} value={roleType}>
            {t(ViewModelSharingUserRoleType.getLocalStringKey(roleType))}
          </option>
        ))}
      </select>
    </div>
  );
};
